import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ModalStyle.css";
import middleware from "../Api/Middleware";
import { BorderedTextInput } from '../HouseStyle/Components/Inputs';
import { ButtonBlue, ButtonLightGrey } from '../HouseStyle/Components/Buttons';
import ToastError from '../Toasts/ToastError';
import { m } from 'framer-motion';
import ToastSuccess from "../Toasts/ToastSuccess";
import SalesChannelDescriptionEditor from '../HouseStyle/Components/SalesChannelDescriptionEditor';

const BrandModal = ({
  brandEdit,
  setBrandEdit,
  brandNew,
  setBrandNew,
  brandEditData,
  AddedOrEditedBrand,
}) => {
  const [showBrand, setShowBrand] = useState(false);
  const [merkName, setMerkName] = useState("");
  const [description, setDescription] = useState("");
  const [channelDescriptions, setChannelDescriptions] = useState({});
  // const [keywords, setKeywords] = useState("");
  const [merkNameEdit, setMerkNameEdit] = useState(brandEditData.name);
  const [descriptionEdit, setDescriptionEdit] = useState(
    brandEditData.description
  );
  const [channelDescriptionsEdit, setChannelDescriptionsEdit] = useState({});
  // const [keywordsEdit, setKeywordsEdit] = useState(brandEditData.keywords);
  const [isEditing, setIsEditing] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [seoAppInstalled, setSeoAppInstalled] = useState(() => {
    const appstore = JSON.parse(localStorage.getItem("appstore"));
    return appstore?.apps?.find(app => app.slug === "seo-duplicates")?.status === 3;
  });

  useEffect(() => {
    if (brandEdit) {
      setMerkNameEdit(brandEditData.name);
      setDescriptionEdit(brandEditData.description);
      // setKeywordsEdit(brandEditData.keywords);
      setIsEditing(true);
    }
  }, [brandEditData, brandEdit]);

  const validateInput = () => {
    if (isEditing && !merkNameEdit.trim()) {
      ToastError("Merk naam is verplicht");
      setShowError(true);
      return false;
    } else if (!isEditing && !merkName.trim()) {
      ToastError("Merk naam is verplicht");
      setShowError(true);
      return false;
    }
    return true;
  };

  const submitNewBrand = async (event) => {
    try {
      if (merkName.trim() === "" && merkNameEdit.trim() === "") {
        ToastError("Vul een merk naam in");
        return;
      }

      if (event) {
        event.preventDefault();
      }
      
      if (!validateInput()) {
        return;
      }
      
      if (isEditing) {
        await middleware.put(`products/brands`, {
          brand_id: brandEditData.brand_id,
          name: merkNameEdit,
          description: descriptionEdit,
          sales_channel_descriptions: channelDescriptionsEdit,
          // keywords: keywordsEdit,
        });

        ToastSuccess(`${merkNameEdit} is succesvol bijgewerkt!`, 'brand_edited', 3000);

        AddedOrEditedBrand();
      } else {
        // Create new brand
        await middleware.post("products/brands", {
          name: merkName,
          description: description,
          sales_channel_descriptions: channelDescriptions,
          // keywords: keywords,
        });

        ToastSuccess(`${merkName} is toegevoegd en klaar voor gebruik`, 'brand_added', 3000);
        
        AddedOrEditedBrand();
      }
      
      setMerkName("");
      setDescription("");
      setChannelDescriptions({});
      // setKeywords("");
      setMerkNameEdit("");
      setDescriptionEdit("");
      setChannelDescriptionsEdit({});
      // setKeywordsEdit("");

      setBrandNew(false);
      setBrandEdit(false);
      setIsEditing(false);
      setShowError(false);
      
    } catch (error) {
      // Check if it's a duplicate entry error
      if (error.response?.data?.error) {
        const errorMessage = error.response.data.error;
        const brandName = isEditing ? merkNameEdit : merkName;
        
        // Check for duplicate entry error (1062 is MySQL duplicate entry error code)
        if (errorMessage.includes('Duplicate entry') || errorMessage.includes('1062')) {
          ToastError(`Merk "${brandName}" bestaat al. Kies een andere naam.`, 'duplicate_brand');
        } else {
          // Generic error message for other database errors
          const action = isEditing ? "bijwerken" : "toevoegen";
          ToastError(`Er is een fout opgetreden bij het ${action} van het merk.`, 'brand_save_error');
        }
      } else {
        // Fallback error message
        ToastError("Er is een onbekende fout opgetreden. Probeer het opnieuw.", 'unknown_error');
      }
      
      // Keep the error state for UI feedback
      setErrorMessage("Er is een fout opgetreden bij het opslaan van het merk");
      setShowError(true);
    }
  };

  return (
    <div>
      <Modal
        id="modalBlueprint"
        show={brandNew}
        onHide={() => {
          setBrandNew(false);
          setShowError(false);
        }}
        centered
        size="xl"
      >
        <Modal.Header className="modalTop d-flex justify-content-between">
          <h4 className="mb-0 fw-semibold">Voeg een merk toe</h4>
          <button
            className="border-0 bg-transparent"
            variant="transparent"
            onClick={() => {
              setBrandNew(false);
              setShowError(false);
            }}
          >
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </button>
        </Modal.Header>
        <Modal.Body className="modalCenter">
          <div className="contendModal w-100">
            <div className="mb-2">
              <BorderedTextInput
                name="merkName"
                label={"Merk naam*"}
                inputValue={merkName}
                setInputValue={setMerkName}
              />
            </div>
            {seoAppInstalled ? (
              <SalesChannelDescriptionEditor
                entityType="brand"
                entityId={null}
                defaultDescription={description}
                onDefaultDescriptionChange={setDescription}
                isEditMode={false}
                channelDescriptions={channelDescriptions}
                onChannelDescriptionsChange={setChannelDescriptions}
                useTextarea={true}
                label="Beschrijving"
              />
            ) : (
              <div className="mb-2">
                <BorderedTextInput
                  name="merkDescription"
                  label={"Beschrijving"}
                  inputValue={description}
                  setInputValue={setDescription}
                />
              </div>
            )}
            {/* <div>
              <BorderedTextInput
                name="merkKeywords"
                label={"Trefwoorden"}
                inputValue={keywords}
                setInputValue={setKeywords}
              />
            </div> */}
          </div>
        </Modal.Body>
        <Modal.Footer className="modalBottom d-flex flex-row justify-content-between">
          <ButtonLightGrey
            text={"Annuleren"}
            onClickFunction={() => {
              setBrandNew(false);
              setShowError(false);
            }}
          />
          <ButtonBlue
            text={"Voeg toe"}
            onClickFunction={() => {
              if (validateInput()) {
                submitNewBrand();
                setBrandNew(false);
              }
            }}
          />
        </Modal.Footer>
      </Modal>

      <Modal
        id="modalEditBrand"
        show={brandEdit}
        onHide={() => {
          setBrandEdit(false);
          setShowError(false);
        }}
        centered
        size="xl"
      >
        <Modal.Header className="modalTop d-flex justify-content-between">
          <h4 className="mb-0 fw-semibold">Bewerken</h4>
          <button
            className="border-0 bg-transparent"
            variant="transparent"
            onClick={() => {
              setBrandEdit(false);
              setShowError(false);
            }}
          >
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </button>
        </Modal.Header>
        <Modal.Body className="modalCenter">
          <div className="contendModal w-100">
            <div className="mb-2">
              <BorderedTextInput
                name="merkName"
                label={"Merk naam*"}
                inputValue={merkNameEdit}
                setInputValue={setMerkNameEdit}
              />
            </div>
            {seoAppInstalled ? (
              <SalesChannelDescriptionEditor
                entityType="brand"
                entityId={brandEditData.brand_id}
                defaultDescription={descriptionEdit}
                onDefaultDescriptionChange={setDescriptionEdit}
                isEditMode={true}
                channelDescriptions={channelDescriptionsEdit}
                onChannelDescriptionsChange={setChannelDescriptionsEdit}
                useTextarea={true}
                label="Beschrijving"
              />
            ) : (
              <div className="mb-2">
                <BorderedTextInput
                  name="merkDescription"
                  label={"Beschrijving"}
                  inputValue={descriptionEdit}
                  setInputValue={setDescriptionEdit}
                />
              </div>
            )}
            {/* <div>
              <BorderedTextInput
                name="merkKeywords"
                label={"Trefwoorden"}
                inputValue={keywordsEdit}
                setInputValue={setKeywordsEdit}
              />
            </div> */}
          </div>
        </Modal.Body>
        <Modal.Footer className="modalBottom d-flex flex-row">
          <ButtonBlue
            text={"Bewerk"}
            onClickFunction={() => {
              if (validateInput()) {
                submitNewBrand();
                setBrandEdit(false);
              }
            }}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BrandModal;